<template>
  <IconLucideMailCheck />
</template>
